import type { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, IconButton, Typography } from '@mui/material';

import useTicketTablePagination from './useTicketTablePagination';

import { styles } from '../table.styles';

interface TicketTablePaginationProps {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  totalTickets: number;
}

const TicketTablePagination: FC<TicketTablePaginationProps> = ({
  setPage,
  totalTickets,
}) => {
  const { t } = useTranslation('followUp');
  const {
    firstTicketNumberOnPage,
    lastTicketNumberOnPage,
    hasPreviousPage,
    hasNextPage,
  } = useTicketTablePagination();
  return (
    <Box sx={styles.tablePagination} aria-label="Pagination">
      <Typography
        sx={(theme) => ({ fontWeight: 600, color: theme.colors.neutral[700] })}
      >
        {t('paginationString', {
          firstId: firstTicketNumberOnPage,
          lastId: lastTicketNumberOnPage,
          totalTickets,
        })}
      </Typography>
      <IconButton
        size="small"
        sx={(theme) => ({
          color: theme.colors.neutral[800],
        })}
        disabled={!hasPreviousPage}
        onClick={() => setPage((prev) => prev - 1)}
        aria-label="previous-page"
      >
        <ArrowBackIosIcon fontSize="inherit" />
      </IconButton>

      <IconButton
        size="small"
        sx={(theme) => ({
          color: theme.colors.neutral[800],
        })}
        disabled={!hasNextPage}
        onClick={() => setPage((prev) => prev + 1)}
        aria-label="next-page"
      >
        <ArrowForwardIosIcon fontSize="inherit" />
      </IconButton>
    </Box>
  );
};

export default TicketTablePagination;
